/* React base class */
import { Component } from "react"

/* Shared utilities (media url, fallbacks) */
import { utils } from "../../helpers"

/* Icon component */
import Icon from "../../components/Icon"

/* Translation */
import { translate } from "../../translates"

/* Widget Lightbox */
class Lightbox extends Component {

    constructor(props) {
        super(props)
        /* State */
        this.state = { i: props.startIndex || 0 }
    }

    componentDidMount = () => {
        document.body.style.overflow = "hidden"
    }

    componentWillUnmount = () => {
        document.body.style.overflow = ""
    }

    /* Draw Step */
    _step = (delta) => {
        const total = this.props.images.length
        if (total < 2) {
            return
        }
        this.setState({ i: (this.state.i + delta + total) % total })
    }

    render = () => {
        const images = this.props.images
        return (
            <div className="lightbox" onClick={this.props.onClose}>
                <div className="lightbox__header" onClick={(e) => e.stopPropagation()}>
                    <div>
                        <span className="lightbox__title">{this.props.title}</span>
                        <span className="lightbox__counter">{this.state.i + 1} / {images.length}</span>
                    </div>
                    <button className="lightbox__close" onClick={this.props.onClose} aria-label={translate("Закрыть")}><Icon name="close" size={20} /></button>
                </div>
                <div className="lightbox__stage" onClick={(e) => e.stopPropagation()}>
                    {images.length > 1 && <button className="lightbox__nav lightbox__nav--prev" onClick={() => this._step(-1)} aria-label={translate("Назад")}><Icon name="chevron_left" size={28} /></button>}
                    <img className="lightbox__main" src={utils.media(images[this.state.i]) || utils.FALLBACK_IMG} alt="" onError={utils.onImgError} />
                    {images.length > 1 && <button className="lightbox__nav lightbox__nav--next" onClick={() => this._step(1)} aria-label={translate("Далее")}><Icon name="chevron_right" size={28} /></button>}
                </div>
                <div className="lightbox__thumbs" onClick={(e) => e.stopPropagation()}>
                    {images.length > 1 && images.map((src, index) => (
                        <button key={`${index}`} className={`lightbox__thumb ${index === this.state.i ? "is-active" : ""}`} onClick={() => this.setState({ i: index })}>
                            <img src={utils.media(src) || utils.FALLBACK_IMG} alt="" onError={utils.onImgError} />
                        </button>
                    ))}
                </div>
            </div>
        )
    }
}

/* Export */
export default Lightbox
